import { useState, useEffect } from 'react';
import { chatbotService, TenantInfo } from '@services/api/chatbot.service';

interface UseTenantResult {
  tenantInfo: TenantInfo | null;
  loading: boolean;
  error: string | null;
}

export function useTenant(): UseTenantResult {
  const [tenantInfo, setTenantInfo] = useState<TenantInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadTenantInfo = async () => {
      try {
        setLoading(true);
        const info = await chatbotService.getTenantInfo();
        setTenantInfo(info);
        setError(null);
      } catch (err: any) {
        console.error('Error loading tenant info:', err);
        setError(err?.message || 'Error al cargar información del tenant');
        setTenantInfo({ slug: 'unknown', name: 'Tu organización' });
      } finally {
        setLoading(false);
      }
    };

    loadTenantInfo();
  }, []);

  return { tenantInfo, loading, error };
}
